import React, { createContext, useContext, useState, useEffect } from 'react';
import log from 'loglevel';
import { useTranslation } from 'react-i18next';
import { usePlayerContext } from '../Context';
import { TextTrackEvents } from '../../sdk/PlayerEvents';
import { Events, State, AudioTrack, TextTrack } from '../../types/player';
import ControlMenu from '../ui/ControlMenu';
import SelectControl, { Item } from '../ui/SelectControl';

const PlaybackRatesSelector = () => {
  const { sdk } = usePlayerContext();
  const { t } = useTranslation();
  const [playbackRates, setPlaybackRates] = useState(sdk.getPlaybackRates());
  const slug = 'playback-rate';
  const [currentPlaybackRate, setCurrentPlaybackRate] = useState(
    sdk.getCurrentPlaybackRate(),
  );

  useEffect(() => {
    sdk.on(Events.PLAYBACKRATE_CHANGED, (rate: number) => {
      setCurrentPlaybackRate(rate);
    });
  }, []);

  const setCurrent = (playbackRate: string) => {
    sdk.setCurrentPlaybackRate(parseFloat(playbackRate));
    sdk.toggleControlMenu(slug);
  };

  if (!sdk.hasPlaybackRates()) {
    return null;
  }

  const items: Item[] = playbackRates.map((playbackRate, index) => {
    return { val: playbackRate, label: 'x' + playbackRate };
  });

  const selector = (
    <div
      className={`${sdk.getClassNamePrefix()}-player-control-menu-list ${sdk.getClassNamePrefix()}-player-control-menu-list-playback-rate`}
    >
      <SelectControl
        items={items}
        currentValue={currentPlaybackRate}
        controlSlug={slug}
        handleAction={setCurrent}
      />
    </div>
  );

  return (
    <ControlMenu
      icon={'gauge'}
      controlClassName={'playback-rate'}
      title={'Playback Speed'}
      content={selector}
    />
  );
};

export default PlaybackRatesSelector;
